import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './NavBar.css';
import { Collapse, Nav, NavItem, Navbar, NavbarToggler } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import BaseUrl from '../../base-api';

const NavBar = () => {
  // const links = [
  // {
  //   label:"Dashboard",
  //   to:"/home/dashboard"
  // },
  // {
  //   label:"Documents for Verification",
  //   to:"/home/applications"
  // },
  // {
  //   label:"Admission Form",
  //   to:"/home/registration-details"
  // },
  // {
  //   label:"My Courses",
  //   to:"/home/my-courses"
  // },
  // ];
  const linkPath = {
    "dashboard": "/SideBar/dashboard",
    "applications": "/SideBar/applications",
    "admissionForm": "/SideBar/registration-details",
    "courses": "/SideBar/my-courses",
    "learnerDetails": "/SideBar/learner-details",
    "session": "/SideBar/SessionDetails",
    "admissions": "/SideBar/admissions",
    "new-admission": "/SideBar/new-admission",

  };
  const Navigate = useNavigate();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [links, setLinks] = useState([]);
  let collapseCondition = screenWidth <= 768 ? true : false;

  const [collapsed, setCollapsed] = useState(!collapseCondition);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);

  };

  useEffect(() => {
    axios.get(`${BaseUrl}/auth/privileges`, {
      headers: {
        "Authorization": localStorage.getItem("$3ingT0k3n")
      }
    }).then(function (response) {
      response.data.forEach(element => {
        console.log(element)
        Object.keys(linkPath).forEach(l => {
          console.log(l);
          if (l == element.key) {
            element['to'] = linkPath[l];
            console.log(element)
          }
        })
      });
      setLinks(response.data);
    })
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleCollapse = () => {
    if (collapseCondition) {
      setCollapsed(!collapsed);
      collapseCondition = false;
    }
  };
  const logout = () => {
    localStorage.removeItem("$3ingT0k3n");
    Navigate("/");
    toast.success("Successfully logout")
  }

  const view = (e) => {
    e.target.classList.add("active");


  }
  return (

    <Navbar style={{ position: 'sticky', top: 150 }}>
      {<Nav vertical style={{ textAlign: 'center', width: "100%" }}>
        {links.map((link, index) => (
          <>
            <NavItem id={`nav${index}`} onClick={view}
              className="p-2 mt-2 "
              style={{
                backgroundColor: "#bbe5ff",

              }}
            >
              <Link
                className="list-group-item list-group-item-action"
                to={link.to}
              // target={link.target}
              // key={link.key}
              // onClick={toggleCollapse}
              >
                {link.label}
              </Link>
            </NavItem>
          </>
        ))}
        <NavItem
          className="p-2 mt-2" style={{ backgroundColor: "#bbe5ff" }}
        ><Link to="/"
          className="list-group-item list-group-item-action"
          onClick={logout}
        // target={link.target}
        // key={link.key}
        // onClick={toggleCollapse}
        >
            Logout
          </Link></NavItem>
      </Nav>}

    </Navbar>






  )
};

NavBar.propTypes = {};

NavBar.defaultProps = {};

export default NavBar;
